import React from 'react';
import DOMPurify from 'dompurify';
import { Button } from '../../components/ui/button';
import { Card } from '../../components/ui/card';
import { TabsContent } from '../../components/ui/tabs';
import { Badge } from '../../components/ui/badge';
import { Label } from '../../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Send, Filter, Info, Trash2, Edit } from 'lucide-react';
import RichTextEditor from '../../components/RichTextEditor';
import FilePickerInput from '../../components/FilePickerInput';
import YouTubeEmbed from '../../components/YouTubeEmbed';
import LessonFiles from '../../components/LessonFiles';
import MessageFiles from '../../components/MessageFiles';

const getFullName = (user) => {
  if (!user) return '';
  const full = `${user.first_name || ''} ${user.last_name || ''}`.trim();
  return full || user.username || '';
};

export default function LessonsTab({ ctx }) {
  const {
    user,
    token,
    classes,
    lessons,
    filteredLessons,
    lessonFilter,
    setLessonFilter,
    boardContent,
    setBoardContent,
    boardFiles,
    setBoardFiles,
    boardFilter,
    setBoardFilter,
    filteredBoardMessages,
    boardMessages,
    handleSendBoardMessage,
    privateContent,
    setPrivateContent,
    privateRecipient,
    setPrivateRecipient,
    privateFiles,
    setPrivateFiles,
    privateFilter,
    setPrivateFilter,
    filteredPrivateMessages,
    privateMessages,
    handleSendPrivateMessage,
    recipients,
    getSenderRoleColor,
    handleEditMessage,
    handleDeleteMessage,
  } = ctx;
  return (
          <TabsContent value="lessons" data-testid="lessons-content">
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <h2 className="text-xl font-semibold text-slate-900">Учебни записи</h2>
                <Select value={lessonFilter} onValueChange={setLessonFilter}>
                  <SelectTrigger className="w-[140px] sm:w-[180px]">
                    <Filter className="h-4 w-4 mr-2" />
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">Всички</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              {filteredLessons.length === 0 ? (
                <Card className="p-8 text-center text-slate-500">
                  Няма учебни записи
                </Card>
              ) : (
                filteredLessons.map((lesson) => (
                  <Card key={lesson.lesson_id} data-testid="lesson-card" className="p-6 border border-slate-200 shadow-sm hover:shadow-md transition-shadow">
                    <div className="flex-1">
                      <div className="flex items-center gap-3 mb-2">
                        <Badge variant="outline" className="text-xs">
                          {new Date(lesson.date).toLocaleDateString('bg-BG')}
                        </Badge>
                        <span className="text-sm text-slate-600">
                          Учител: {lesson.teacher_name}
                        </span>
                      </div>
                      <p className="text-slate-900 prose prose-sm max-w-none" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(lesson.description) }} />
                      <YouTubeEmbed html={lesson.description} />
                      <LessonFiles lesson={lesson} token={token} />
                    </div>
                  </Card>
                ))
              )}
            </div>
          </TabsContent>
  );
}
